import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header align-items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h4", { style: {"color":"#004761"} }, "Classgroup Details", -1)
const _hoisted_4 = { class: "position-absolute top-0 end-0 mt-2 me-3 pt-2 pe-1 z-index-1" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "fas fa-arrow-left" }, null, -1)
const _hoisted_6 = { class: "card-body bg-light" }
const _hoisted_7 = { class: "mb-3" }
const _hoisted_8 = { class: "mb-3" }
const _hoisted_9 = { class: "mb-3" }
const _hoisted_10 = ["textContent"]
const _hoisted_11 = ["textContent"]
const _hoisted_12 = ["value", "textContent"]
const _hoisted_13 = ["textContent"]
const _hoisted_14 = { class: "mb-3" }
const _hoisted_15 = { class: "mb-3 d-none" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { for: "students-emails" }, "Students", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_18 = { class: "mb-3" }
const _hoisted_19 = ["textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Input = _resolveComponent("Input")!
  const _component_Field = _resolveComponent("Field")!
  const _component_smart_tagz = _resolveComponent("smart-tagz")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_router_link, {
          class: "btn btn-falcon-default btn-sm",
          "data-bs-toggle": "tooltip",
          "data-bs-placement": "top",
          title: "",
          "data-bs-original-title": "Back to Group",
          to: {
            name: 'Home',
          }
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_Form, {
        id: "classgroup-create-form",
        onSubmit: _ctx.processForm,
        initialValues: _ctx.classGroup,
        "validation-schema": _ctx.schema,
        onKeypress: _cache[1] || (_cache[1] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
      }, {
        default: _withCtx(({ errors }) => [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_Input, {
              id: "classgroup-group-code",
              label: "Group Code",
              name: "code",
              placeholder: "Group Code",
              value: _ctx.classGroup.code,
              error: errors.code,
              disabled: ""
            }, null, 8, ["value", "error"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_Input, {
              id: "classgroup-create-group-name",
              label: "Group Name*",
              name: "name",
              placeholder: "Group Name",
              value: _ctx.classGroup.name,
              error: errors.name
            }, null, 8, ["value", "error"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("label", {
              for: "classgroup-create-language",
              textContent: _toDisplayString('Language Pair')
            }, null, 8, _hoisted_10),
            _createVNode(_component_Field, {
              id: "classgroup-create-language",
              name: "language",
              modelValue: _ctx.classGroupLanguageMapping,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.classGroupLanguageMapping) = $event)),
              "aria-label": "Select Language Pair"
            }, {
              default: _withCtx(({ field }) => [
                _createElementVNode("select", _mergeProps({ class: "form-select" }, field), [
                  _createElementVNode("option", {
                    value: "",
                    disabled: "",
                    textContent: _toDisplayString('Select Language Pair...')
                  }, null, 8, _hoisted_11),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.languages, (language, idx) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: language.id,
                      key: idx,
                      textContent: _toDisplayString(language.description)
                    }, null, 8, _hoisted_12))
                  }), 128))
                ], 16)
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createElementVNode("div", {
              class: "text-danger text-sm",
              textContent: _toDisplayString(errors.language)
            }, null, 8, _hoisted_13)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_Input, {
              id: "classgroup-number-students",
              label: "Number of Students",
              name: "studentCount",
              placeholder: "Number of Students",
              value: _ctx.classGroup.studentCount,
              error: errors.studentCount,
              disabled: ""
            }, null, 8, ["value", "error"])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createVNode(_component_smart_tagz, {
              id: "students-emails",
              "input-placeholder": "Enter students emails",
              editable: "",
              allowPaste: { delimiter: ',' },
              theme: {
              background: '#fff',
            },
              "on-changed": _ctx.addStudents
            }, null, 8, ["on-changed"])
          ]),
          _hoisted_17,
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("button", {
              class: "btn btn-primary d-block w-100 mt-3",
              type: "submit",
              name: "submit",
              textContent: _toDisplayString('Save')
            }, null, 8, _hoisted_19)
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "initialValues", "validation-schema"])
    ])
  ]))
}